/**
 * Die Auswahl «Anzahl Zimmer» — EINE Quelle für die ganze App
 * (Entscheid Peter, 31.08.2026).
 *
 * Vorher baute sich jede der beiden Wohnungs-Masken die Liste selbst — und
 * zwar UNTERSCHIEDLICH: Beim Anlegen begann sie bei 0, beim Bearbeiten bei
 * 0.5. Die Prüfregel verlangt aber «grösser als 0» (`StoreApartmentRequest`,
 * `rooms => gt:0`), also liess sich beim Anlegen ein Wert wählen, den der
 * Server anschliessend ablehnte. Genau dafür ist eine gemeinsame Quelle da.
 *
 * Halbe Schritte bis 19.5, weil 3.5- und 4.5-Zimmer-Wohnungen der Normalfall
 * sind.
 */
export const rooms = Array.from({ length: 39 }, (_, index) => {
    const wert = (index + 1) / 2;

    return { name: wert, value: wert };
});

export default rooms;
